import { css } from "styled-components";

import open_sans_v17_latin_ext_latin_300_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300.eot";
import open_sans_v17_latin_ext_latin_300_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300.woff2";
import open_sans_v17_latin_ext_latin_300_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300.woff";
import open_sans_v17_latin_ext_latin_300_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300.ttf";
import open_sans_v17_latin_ext_latin_300_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300.svg";
import open_sans_v17_latin_ext_latin_300italic_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300italic.eot";
import open_sans_v17_latin_ext_latin_300italic_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300italic.woff2";
import open_sans_v17_latin_ext_latin_300italic_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300italic.woff";
import open_sans_v17_latin_ext_latin_300italic_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300italic.ttf";
import open_sans_v17_latin_ext_latin_300italic_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-300italic.svg";
import open_sans_v17_latin_ext_latin_regular_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-regular.eot";
import open_sans_v17_latin_ext_latin_regular_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-regular.woff2";
import open_sans_v17_latin_ext_latin_regular_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-regular.woff";
import open_sans_v17_latin_ext_latin_regular_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-regular.ttf";
import open_sans_v17_latin_ext_latin_regular_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-regular.svg";
import open_sans_v17_latin_ext_latin_italic_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-italic.eot";
import open_sans_v17_latin_ext_latin_italic_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-italic.woff2";
import open_sans_v17_latin_ext_latin_italic_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-italic.woff";
import open_sans_v17_latin_ext_latin_italic_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-italic.ttf";
import open_sans_v17_latin_ext_latin_italic_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-italic.svg";
import open_sans_v17_latin_ext_latin_600_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600.eot";
import open_sans_v17_latin_ext_latin_600_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600.woff2";
import open_sans_v17_latin_ext_latin_600_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600.woff";
import open_sans_v17_latin_ext_latin_600_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600.ttf";
import open_sans_v17_latin_ext_latin_600_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600.svg";
import open_sans_v17_latin_ext_latin_600italic_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600italic.eot";
import open_sans_v17_latin_ext_latin_600italic_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600italic.woff2";
import open_sans_v17_latin_ext_latin_600italic_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600italic.woff";
import open_sans_v17_latin_ext_latin_600italic_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600italic.ttf";
import open_sans_v17_latin_ext_latin_600italic_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-600italic.svg";
import open_sans_v17_latin_ext_latin_700_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700.eot";
import open_sans_v17_latin_ext_latin_700_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700.woff2";
import open_sans_v17_latin_ext_latin_700_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700.woff";
import open_sans_v17_latin_ext_latin_700_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700.ttf";
import open_sans_v17_latin_ext_latin_700_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700.svg";
import open_sans_v17_latin_ext_latin_700italic_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700italic.eot";
import open_sans_v17_latin_ext_latin_700italic_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700italic.woff2";
import open_sans_v17_latin_ext_latin_700italic_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700italic.woff";
import open_sans_v17_latin_ext_latin_700italic_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700italic.ttf";
import open_sans_v17_latin_ext_latin_700italic_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-700italic.svg";
import open_sans_v17_latin_ext_latin_800_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800.eot";
import open_sans_v17_latin_ext_latin_800_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800.woff2";
import open_sans_v17_latin_ext_latin_800_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800.woff";
import open_sans_v17_latin_ext_latin_800_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800.ttf";
import open_sans_v17_latin_ext_latin_800_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800.svg";
import open_sans_v17_latin_ext_latin_800italic_eot from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800italic.eot";

import open_sans_v17_latin_ext_latin_800italic_woff2 from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800italic.woff2";
import open_sans_v17_latin_ext_latin_800italic_woff from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800italic.woff";
import open_sans_v17_latin_ext_latin_800italic_ttf from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800italic.ttf";
import open_sans_v17_latin_ext_latin_800italic_svg from "src/assets/fonts/open-sans/open-sans-v17-latin-ext_latin-800italic.svg";

const ieFix = "?#iefix";
const svgSuffix = "#OpenSans";

const fontFace = () => css`
  /* open-sans-300 - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    src: url(${open_sans_v17_latin_ext_latin_300_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Light"), local("OpenSans-Light"),
      url(${open_sans_v17_latin_ext_latin_300_eot}) format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_300_woff2})
        format("woff2"),
      /* Super Modern Browsers */ url(${open_sans_v17_latin_ext_latin_300_woff})
        format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_300_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_300_svg + svgSuffix}) format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-300italic - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 300;
    src: url(${open_sans_v17_latin_ext_latin_300italic_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Light Italic"), local("OpenSans-LightItalic"),
      url(${open_sans_v17_latin_ext_latin_300italic_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_300italic_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_300italic_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_300italic_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_300italic_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-regular - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    src: url(${open_sans_v17_latin_ext_latin_regular_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Regular"), local("OpenSans-Regular"),
      url(${open_sans_v17_latin_ext_latin_regular_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_regular_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_regular_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_regular_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_regular_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-italic - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 400;
    src: url(${open_sans_v17_latin_ext_latin_italic_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Italic"), local("OpenSans-Italic"),
      url(${open_sans_v17_latin_ext_latin_italic_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_italic_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_italic_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_italic_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_italic_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-600 - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    src: url(${open_sans_v17_latin_ext_latin_600_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans SemiBold"), local("OpenSans-SemiBold"),
      url(${open_sans_v17_latin_ext_latin_600_eot}) format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_600_woff2})
        format("woff2"),
      /* Super Modern Browsers */ url(${open_sans_v17_latin_ext_latin_600_woff})
        format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_600_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_600_svg + svgSuffix}) format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-600italic - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 600;
    src: url(${open_sans_v17_latin_ext_latin_600italic_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans SemiBold Italic"), local("OpenSans-SemiBoldItalic"),
      url(${open_sans_v17_latin_ext_latin_600italic_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_600italic_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_600italic_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_600italic_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_600italic_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-700 - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    src: url(${open_sans_v17_latin_ext_latin_700_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Bold"), local("OpenSans-Bold"),
      url(${open_sans_v17_latin_ext_latin_700_eot}) format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_700_woff2})
        format("woff2"),
      /* Super Modern Browsers */ url(${open_sans_v17_latin_ext_latin_700_woff})
        format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_700_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_700_svg + svgSuffix}) format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-700italic - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 700;
    src: url(${open_sans_v17_latin_ext_latin_700italic_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans Bold Italic"), local("OpenSans-BoldItalic"),
      url(${open_sans_v17_latin_ext_latin_700italic_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_700italic_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_700italic_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_700italic_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_700italic_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-800 - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 800;
    src: url(${open_sans_v17_latin_ext_latin_800_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans ExtraBold"), local("OpenSans-ExtraBold"),
      url(${open_sans_v17_latin_ext_latin_800_eot}) format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_800_woff2})
        format("woff2"),
      /* Super Modern Browsers */ url(${open_sans_v17_latin_ext_latin_800_woff})
        format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_800_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_800_svg + svgSuffix}) format("svg"); /* Legacy iOS */
    font-display: swap;
  }
  /* open-sans-800italic - latin-ext_latin */
  @font-face {
    font-family: "Open Sans";
    font-style: italic;
    font-weight: 800;
    src: url(${open_sans_v17_latin_ext_latin_800italic_eot +
    ieFix}); /* IE9 Compat Modes */
    src: local("Open Sans ExtraBold Italic"), local("OpenSans-ExtraBoldItalic"),
      url(${open_sans_v17_latin_ext_latin_800italic_eot})
        format("embedded-opentype"),
      /* IE6-IE8 */ url(${open_sans_v17_latin_ext_latin_800italic_woff2})
        format("woff2"),
      /* Super Modern Browsers */
        url(${open_sans_v17_latin_ext_latin_800italic_woff}) format("woff"),
      /* Modern Browsers */ url(${open_sans_v17_latin_ext_latin_800italic_ttf})
        format("truetype"),
      /* Safari, Android, iOS */
        url(${open_sans_v17_latin_ext_latin_800italic_svg + svgSuffix})
        format("svg"); /* Legacy iOS */
    font-display: swap;
  }
`;

export default fontFace;
